import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setDeeplinkData } from '../actions';

const usePersistDeeplinkData = ({
  deeplinkKey,
  hasDeeplinkParams,
  queryParams,
}) => {
  const dispatch = useDispatch();
  const [persistedDeeplinkKey, setPersistedDeeplinkKey] = useState('');

  useEffect(() => {
    if (!hasDeeplinkParams) {
      setPersistedDeeplinkKey('');
      return;
    }

    if (persistedDeeplinkKey === deeplinkKey) return;

    dispatch(
      setDeeplinkData({
        action: queryParams.action || null,
        payload_code: queryParams.code || null,
        authority: queryParams.authority || null,
        country: queryParams.country || null,
        meta: {
          application_licence_plate:
            queryParams.applicationsLicensePlate || null,
          applications_code: queryParams.applicationsCode || null,
        },
        needsDeeplinkRedirection: !!queryParams.action,
      })
    );
    setPersistedDeeplinkKey(deeplinkKey);
  }, [
    deeplinkKey,
    dispatch,
    hasDeeplinkParams,
    persistedDeeplinkKey,
    queryParams,
  ]);

  return hasDeeplinkParams && persistedDeeplinkKey !== deeplinkKey;
};

export default usePersistDeeplinkData;
